/* AIM page navigation · the bar under the product gallery.
   Items: the links Liquid rendered (Overview, Specs, Instructions) plus, in page
   order, every element with data-aim-nav="Label". Pins under the store header,
   follows the header as it hides and reveals, and runs an IntersectionObserver
   scrollspy that slides one gold underline. */
(() => {
	const SEL = "[data-aim-pnav]";
	const REDUCE = window.matchMedia("(prefers-reduced-motion: reduce)");
	let s = null;

	const headerEl = () => document.querySelector(".shopify-section-header");
	const stickyEl = () => document.querySelector("sticky-header");
	const stickyType = () => {
		const el = stickyEl();
		return el ? el.getAttribute("data-sticky-type") || "on-scroll-up" : "none";
	};
	const headerHeight = () => {
		const h = headerEl();
		return h ? h.getBoundingClientRect().height : 0;
	};
	const headerBottom = () => {
		const h = headerEl();
		return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
	};
	const keepHeaderHidden = () => {
		const el = stickyEl();
		if (el && stickyType() === "on-scroll-up") el.dispatchEvent(new CustomEvent("preventHeaderReveal"));
	};
	const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "section";

	function readDefs(nav) {
		return [...nav.querySelectorAll(".aim-pnav__link")]
			.map((a) => ({
				id: decodeURIComponent((a.getAttribute("href") || "").replace(/^#/, "")),
				label: a.textContent.trim(),
			}))
			.filter((d) => d.id && d.label);
	}

	function collect() {
		const found = [];
		const usable = (el) => el && !s.nav.contains(el) && !el.closest("quick-add-modal, modal-dialog") && el.getClientRects().length > 0;

		s.defs.forEach((d) => {
			const el = document.getElementById(d.id);
			if (usable(el)) found.push({ el, label: d.label });
		});

		const reviews = document.getElementById("testimonials-quote");
		if (usable(reviews) && !reviews.hasAttribute("data-aim-nav")) {
			found.push({ el: reviews, label: s.nav.getAttribute("data-reviews-label") || "Reviews" });
		}

		document.querySelectorAll("[data-aim-nav]").forEach((el) => {
			const label = (el.getAttribute("data-aim-nav") || "").trim();
			if (!label || !usable(el)) return;
			if (!el.id) {
				let id = "aim-" + slug(label);
				for (let n = 2; document.getElementById(id); n++) id = "aim-" + slug(label) + "-" + n;
				el.id = id;
			}
			found.push({ el, label });
		});

		found.sort((a, b) => (a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));

		const seen = new Set();
		return found.filter((it) => {
			const key = it.label.toLowerCase();
			if (seen.has(key) || seen.has(it.el)) return false;
			seen.add(key);
			seen.add(it.el);
			return true;
		});
	}

	function render() {
		const items = collect();
		s.list.textContent = "";
		s.active = null;
		s.items = items.map((it) => {
			const li = document.createElement("li");
			const a = document.createElement("a");
			const label = document.createElement("span");
			li.className = "aim-pnav__item";
			a.className = "aim-pnav__link";
			a.href = "#" + encodeURIComponent(it.el.id);
			label.className = "aim-pnav__label";
			label.textContent = it.label;
			a.appendChild(label);
			li.appendChild(a);
			s.list.appendChild(li);
			return { el: it.el, label: it.label, link: a, text: label, inZone: false };
		});
		s.nav.hidden = s.items.length < 2;
		s.ink.classList.remove("is-on");
		measure();
		spy();
		fades();
		kick(0);
	}

	/* ---------- pinning ---------- */
	function measure() {
		s.barH = s.bar.getBoundingClientRect().height || 48;
		const r = s.nav.getBoundingClientRect();
		s.nav.style.setProperty("--aim-pnav-x", r.left + "px");
		s.nav.style.setProperty("--aim-pnav-w", r.width + "px");
	}

	function frame() {
		s.raf = 0;
		if (!s.nav.hidden) {
			const top = headerBottom();
			const pinned = s.nav.getBoundingClientRect().top < top;
			if (pinned !== s.pinned) {
				s.pinned = pinned;
				s.nav.classList.toggle("is-pinned", pinned);
				if (!pinned) {
					s.bar.style.transform = "";
					s.y = null;
				}
			}
			if (pinned) {
				let y = top;
				const main = s.nav.closest("main");
				if (main) y = Math.min(y, main.getBoundingClientRect().bottom - s.barH);
				if (y !== s.y) {
					s.y = y;
					s.bar.style.transform = "translate3d(0," + y + "px,0)";
				}
			}
		}
		if (performance.now() < s.until) s.raf = requestAnimationFrame(frame);
	}

	function kick(ms) {
		s.until = Math.max(s.until, performance.now() + ms);
		if (!s.raf) s.raf = requestAnimationFrame(frame);
	}

	/* ---------- scrollspy ---------- */
	function spy() {
		if (s.io) s.io.disconnect();
		const head = stickyType() === "none" ? 0 : headerHeight();
		const top = Math.min(Math.ceil(head + s.barH) + 4, Math.floor(window.innerHeight * 0.45));
		s.io = new IntersectionObserver(
			(entries) => {
				entries.forEach((e) => {
					const it = s.items.find((i) => i.el === e.target);
					if (it) it.inZone = e.isIntersecting;
				});
				pick();
			},
			{ rootMargin: "-" + top + "px 0px -50% 0px", threshold: 0 }
		);
		s.items.forEach((it) => s.io.observe(it.el));
	}

	function pick() {
		if (s.lock || s.hold) return;
		setActive(s.items.find((i) => i.inZone) || null);
	}

	function setActive(it) {
		if (s.active === it) return;
		if (s.active) s.active.link.removeAttribute("aria-current");
		s.active = it;
		if (it) it.link.setAttribute("aria-current", "true");
		placeInk();
		if (it) showInBar(it);
	}

	function placeInk() {
		const ink = s.ink;
		const it = s.active;
		if (!it) {
			ink.classList.remove("is-on");
			return;
		}
		const sr = s.scroller.getBoundingClientRect();
		const tr = it.text.getBoundingClientRect();
		const t = "translate3d(" + (tr.left - sr.left + s.scroller.scrollLeft) + "px,0,0) scaleX(" + tr.width + ")";
		if (ink.classList.contains("is-on")) {
			ink.style.transform = t;
			return;
		}
		ink.style.transition = "none";
		ink.style.transform = t;
		void ink.offsetWidth;
		ink.style.transition = "";
		ink.classList.add("is-on");
	}

	function showInBar(it) {
		const sc = s.scroller;
		const max = sc.scrollWidth - sc.clientWidth;
		if (max <= 1) return;
		const pad = 40;
		const x = it.link.getBoundingClientRect().left - sc.getBoundingClientRect().left + sc.scrollLeft;
		const w = it.link.offsetWidth;
		if (x >= sc.scrollLeft + pad && x + w <= sc.scrollLeft + sc.clientWidth - pad) return;
		const left = Math.max(0, Math.min(max, x - (sc.clientWidth - w) / 2));
		sc.scrollTo({ left, behavior: REDUCE.matches ? "auto" : "smooth" });
	}

	function fades() {
		const sc = s.scroller;
		const max = sc.scrollWidth - sc.clientWidth;
		sc.classList.toggle("is-fade-l", max > 1 && sc.scrollLeft > 1);
		sc.classList.toggle("is-fade-r", max > 1 && sc.scrollLeft < max - 1);
	}

	/* ---------- jumping ---------- */
	const gap = () => (window.innerWidth < 750 ? 16 : 24);
	const offset = () => (stickyType() === "always" ? headerHeight() : 0) + s.barH + gap();

	function goTo(it, instant) {
		const y0 = window.scrollY;
		const dest = Math.max(0, Math.round(it.el.getBoundingClientRect().top + y0 - offset()));
		if (dest < y0) keepHeaderHidden();
		s.hold = null;
		s.lock = it;
		setActive(it);
		window.scrollTo({ top: dest, behavior: instant || REDUCE.matches ? "auto" : "smooth" });
		watchEnd(it);
	}

	function watchEnd(it) {
		const t0 = performance.now();
		let last = window.scrollY;
		let still = 0;
		let moved = false;
		const tick = () => {
			if (s.lock !== it) return;
			const y = window.scrollY;
			if (Math.abs(y - last) < 0.5) still++;
			else {
				still = 0;
				moved = true;
				last = y;
			}
			if ((moved && still >= 6) || still >= 20 || performance.now() - t0 > 3000) settle(it, 0);
			else requestAnimationFrame(tick);
		};
		requestAnimationFrame(tick);
	}

	function settle(it, n) {
		if (s.lock !== it) return;
		const off = it.el.getBoundingClientRect().top - (headerBottom() + s.barH + gap());
		if (Math.abs(off) > 2 && n < 3) {
			if (off < 0) keepHeaderHidden();
			window.scrollTo({ top: window.scrollY + off, behavior: "auto" });
			requestAnimationFrame(() => requestAnimationFrame(() => settle(it, n + 1)));
			return;
		}
		s.lock = null;
		s.hold = it;
		it.el.classList.add("aim-pnav-target");
		if (!it.el.hasAttribute("tabindex")) it.el.setAttribute("tabindex", "-1");
		it.el.focus({ preventScroll: true });
	}

	function cancelJump() {
		if (!s || !s.lock) return;
		s.lock = null;
		pick();
	}

	function onClick(e) {
		const a = e.target.closest(".aim-pnav__link");
		if (!a || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
		const it = s.items.find((i) => i.link === a);
		if (!it) return;
		e.preventDefault();
		goTo(it, false);
	}

	/* ---------- lifecycle ---------- */
	function teardown() {
		if (!s) return;
		s.ac.abort();
		if (s.io) s.io.disconnect();
		if (s.mo) s.mo.disconnect();
		if (s.ro) s.ro.disconnect();
		if (s.raf) cancelAnimationFrame(s.raf);
		s = null;
	}

	function init() {
		const nav = document.querySelector(SEL);
		if (s && s.nav === nav && nav.isConnected) {
			render();
			return;
		}
		teardown();
		if (!nav || nav.closest("quick-add-modal, modal-dialog")) return;
		if (!nav.aimDefs) nav.aimDefs = readDefs(nav);

		s = {
			nav,
			defs: nav.aimDefs,
			bar: nav.querySelector(".aim-pnav__bar"),
			scroller: nav.querySelector(".aim-pnav__scroller"),
			list: nav.querySelector(".aim-pnav__list"),
			ink: nav.querySelector(".aim-pnav__ink"),
			items: [],
			active: null,
			pinned: false,
			y: null,
			raf: 0,
			until: 0,
			lock: null,
			hold: null,
			barH: 48,
			ac: new AbortController(),
		};
		if (!s.bar || !s.scroller || !s.list || !s.ink) {
			s = null;
			return;
		}
		const on = { signal: s.ac.signal, passive: true };

		window.addEventListener(
			"scroll",
			() => {
				kick(0);
				if (s.hold && !s.lock) {
					s.hold = null;
					pick();
				}
			},
			on
		);
		let resizeT = 0;
		window.addEventListener(
			"resize",
			() => {
				clearTimeout(resizeT);
				resizeT = setTimeout(() => {
					measure();
					spy();
					placeInk();
					fades();
					kick(0);
				}, 120);
			},
			on
		);
		["wheel", "touchstart", "keydown"].forEach((type) => window.addEventListener(type, cancelJump, on));
		s.scroller.addEventListener("scroll", fades, on);
		s.list.addEventListener("click", onClick, { signal: s.ac.signal });

		const header = headerEl();
		if (header) {
			s.mo = new MutationObserver(() => kick(400));
			s.mo.observe(header, { attributes: true, attributeFilter: ["class"] });
		}
		s.ro = new ResizeObserver(() => {
			measure();
			placeInk();
			fades();
			kick(0);
		});
		s.ro.observe(nav);
		if (header) s.ro.observe(header);

		render();

		const hash = decodeURIComponent(location.hash.slice(1));
		const deep = hash && s.items.find((i) => i.el.id === hash);
		if (deep) {
			const jump = () => s && goTo(deep, true);
			if (document.readyState === "complete") jump();
			else window.addEventListener("load", jump, { once: true, signal: s.ac.signal });
		}
	}

	let reinitT = 0;
	const reinit = () => {
		clearTimeout(reinitT);
		reinitT = setTimeout(init, 60);
	};
	["shopify:section:load", "shopify:section:unload", "shopify:section:reorder"].forEach((type) =>
		document.addEventListener(type, reinit)
	);

	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
	else init();
})();
